'use client';

import { forwardRef, type ChangeEvent, type ComponentProps } from 'react';

import { Input } from '@/components/ui/input';
import {
  formatSaleDateMask,
  SALE_DATE_MASK_MAX_LENGTH,
  SALE_DATE_MASK_PLACEHOLDER,
} from '../../utils/sale-date-mask.utils';

type SaleDateMaskedInputProps = Omit<ComponentProps<typeof Input>, 'onChange' | 'type'> & {
  onChange: (value: string) => void;
};

export const SaleDateMaskedInput = forwardRef<HTMLInputElement, SaleDateMaskedInputProps>(
  (
    {
      onChange,
      placeholder = SALE_DATE_MASK_PLACEHOLDER,
      maxLength = SALE_DATE_MASK_MAX_LENGTH,
      inputMode = 'numeric',
      ...props
    },
    ref,
  ) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      onChange(formatSaleDateMask(event.target.value));
    };

    return (
      <Input
        {...props}
        ref={ref}
        type="text"
        inputMode={inputMode}
        placeholder={placeholder}
        maxLength={maxLength}
        onChange={handleChange}
        autoComplete="off"
      />
    );
  },
);

SaleDateMaskedInput.displayName = 'SaleDateMaskedInput';
